import { Box, Button } from '@mui/material'
import { Table } from 'shared/ui/Table/Table'
import React, { useMemo } from 'react'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { openTab } from '../Helpers'
import { copyToClipboard } from 'shared/utils'
import Configs from 'infrastructure/config/environment'
import { NewTreeData, newTreesAtom, partnerIdAtom } from './atoms'

export function NewTreesTable() {
  const partnerKey = useAtomValue(partnerIdAtom)
  const treeColumns = useTreeTableColumns()
  const trees = useAtomValue(newTreesAtom)

  if (!trees.length) return null

  return (
    <Box padding="10px">
      <Box>
        <Table
          title={`${partnerKey} Trees`}
          canExport={true}
          items={trees}
          columns={treeColumns}
        />
      </Box>
    </Box>
  )
}

export function useTreeTableColumns() {
  return useMemo(() => {
    return [
      {
        title: <strong>Title</strong>,
        width: 100,
        rowContent({ title }: NewTreeData) {
          return title
        },
      },
      {
        title: <strong>Link</strong>,
        width: 100,
        rowContent(item: NewTreeData) {
          const url = urlForItem(item)
          return <Button onClick={() => openTab(url)}>Open Link</Button>
        },
        rowString(item: NewTreeData) {
          return urlForItem(item)
        },
      },
      {
        title: <strong>Link</strong>,
        width: 100,
        rowContent(item: NewTreeData) {
          const url = urlForItem(item)
          return <Button onClick={() => copyToClipboard(url)}>Copy Link</Button>
        },
        skipExport: true,
      },
    ]
  }, [])
}

function urlForItem({ tree_id, tree_version }: NewTreeData) {
  return `${Configs().AppUrl}/curriculum/${tree_id}:${tree_version}`
}
